import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { faEllipsisV } from '@fortawesome/pro-duotone-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Menu, Dropdown, Button } from 'antd'
import { LearningPath } from 'graphqlAPI'
import Profiles from 'components/reusables/profiles'
import { Options } from 'components/administration/components/learningPaths/styled'
import { LearningPathsColumns, prefixTable } from './constants'
import LearningPathProgress from './LearningPathProgress'

type Data = LearningPath

interface useColumnsProps {
  onDownload: (id: string) => void
}

export function useColumns({ onDownload }: useColumnsProps) {
  const { t } = useTranslation()

  const prefixHeaders = `${prefixTable}.headers`

  const columns = useMemo(
    () => [
      {
        title: t(`${prefixHeaders}.name`),
        key: LearningPathsColumns.name,
        sorteable: true,
        hideable: false,
        width: 70,
        render: (_: any, { name }: Data) => {
          return <div>{name}</div>
        },
      },
      {
        title: t(`${prefixHeaders}.lmsProfile`),
        key: LearningPathsColumns.lmsProfile,
        width: 170,
        sorteable: true,
        render: (_: any, { profiles }: Data) => (
          <>{profiles ? <Profiles items={profiles} /> : null}</>
        ),
      },
      {
        title: t(`${prefixHeaders}.usersCount`),
        key: LearningPathsColumns.usersCount,
        width: 70,
        sorteable: true,
        render: (_: any, { usersCount }: Data) => usersCount || 0,
      },
      {
        title: t(`${prefixHeaders}.courses`),
        key: LearningPathsColumns.coursesCount,
        width: 30,
        sorteable: true,
        render: (_, { coursesCount }: Data) => (
          <span>{coursesCount || '---'}</span>
        ),
      },
      {
        title: t(`${prefixHeaders}.progress`),
        key: LearningPathsColumns.progress,
        width: 60,
        sorteable: true,
        render: (_, { id, monitoring }: Data) =>
          (monitoring && (
            <LearningPathProgress
              id={'progress-' + id}
              progress={{
                finish: monitoring.usersFinish,
                inProgress: monitoring.usersInProgress,
                pending: monitoring.usersPending,
              }}
            />
          )) || <div className="text-center">---</div>,
      },
      {
        width: 66,
        hideable: false,
        align: 'center',
        fixed: 'right',
        render: (data: Data) => (
          <Dropdown
            placement="bottomRight"
            overlay={
              <Menu>
                <Menu.Item onClick={() => onDownload(data.id)}>
                  {t(`${prefixHeaders}.download`)}
                </Menu.Item>
              </Menu>
            }
          >
            <Options>
              <Button type="link">
                <FontAwesomeIcon icon={faEllipsisV} />
              </Button>
            </Options>
          </Dropdown>
        ),
      },
    ],
    [onDownload, prefixHeaders, t]
  )
  return columns
}
